import { css } from 'config/emotionCss';

/** `mobileIcon` is not an antd prop, so it never reaches the semantic-slot function. */
export const mobileIconStyle = css`
  > .ant-btn-icon {
    display: none !important;
  }

  @media screen and (max-width: 767px) {
    padding: 4px 9px 4px 9px;

    > .ant-btn-icon {
      display: flex !important;

      & + span {
        display: none !important;
      }
    }
  }
`;
